export default __webpack_public_path__ + "static/media/records.e49a9e8f.svg";